import { render, staticRenderFns } from "./solicitudPspAprob2.vue?vue&type=template&id=52b97dac&scoped=true"
import script from "./solicitudPspAprob2.vue?vue&type=script&lang=js"
export * from "./solicitudPspAprob2.vue?vue&type=script&lang=js"
import style0 from "./solicitudPspAprob2.vue?vue&type=style&index=0&id=52b97dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b97dac",
  null
  
)

export default component.exports